import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './LoginPage.scss';

const LoginPage: React.FC = () => {
  const { initiateLogin, sessionMessage, sessionState } = useAuth();

  const handleSignIn = () => {
    initiateLogin();
  };

  const getAlertClass = () => {
    if (sessionState === 'expired') return 'alert-warning';
    if (sessionState === 'logged_out') return 'alert-info';
    return '';
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <img 
            className="login-logo" 
            src="https://images.squarespace-cdn.com/content/v1/5e0f65245425f3307a8ba190/1610141473546-Y7JTPTT2J9EOVSSTUQ1U/static1.squarespace-2.png?format=1500w" 
            alt="Company Logo"
          />
          
          <h1 className="login-title">ACCOUNT CONNECTIONS</h1>
          
          {sessionMessage && (
            <div className={`login-alert ${getAlertClass()}`}>
              {sessionMessage}
            </div>
          )}
          
          
          <button 
            className="login-button"
            onClick={handleSignIn}
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 3H21V9M9 21H3V15M21 3L13.5 10.5M3 21L10.5 13.5" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;